<div class="container pr-0">
  <a href="https://datos.cdmx.gob.mx" class="navbar-brand pt-2 pb-2">
    <img src="assets/images/logo-cdmx-datos.svg" alt="Logotipo de la CDMX" class="hd-inline-block align-top" alt="Logo del Gobierno de la Ciudad de México" />
  </a>

  <!-- div class="form-inline my-2 my-lg-0">
    <div class="dropdown" *ngIf="llaveData">
      <button class="btn btn-default dropdown-toggle mr-2 pr-0" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <span class="float-left mr-2" *ngIf="active"><img src="assets/images/user_lightmode.svg" alt="icono de usuario" width="24px" /></span>
        <span class="float-left mr-2" *ngIf="!active"><img src="assets/images/user_darkmode.svg" alt="icono de usuario" width="24px" height="24px" /></span>
        <span class="float-left d-none d-md-block" style="padding-top: 2px;">{{llaveData.nombre}} {{llaveData.primerApellido}}</span>
      </button>
      <div class="dropdown-menu  dropdown-menu-right" aria-labelledby="dropdownMenuButton" *ngIf="llaveData">
        <a class="dropdown-item" (click)="ngLogout()">Cerrar sesión</a>
      </div>
    </div>
    <button class="btn btn-default my-2 mr-2 my-sm-0 pr-0" (click)="ngToggle(1)" title="Cambiar modo de visualización">
      <span class="sr-only">Cambiar modo de visualización</span>
      <span *ngIf="active"><img src="assets/images/lightmode.svg" alt="Icono de sol" width="24px" /></span>
      <span *ngIf="!active"><img src="assets/images/darkmode.svg" alt="Icono de luna" width="24px" height="24px" /></span>
    </button>
  </div -->
</div>

<nav id="nav-menu" class="navbar navbar-expand-lg bg-success py-0">
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"><i class="fas fa-bars text-light pt-1"></i></span>
  </button>
  <div class="collapse navbar-collapse justify-content-center pl-3" id="navbarNavAltMarkup">
    <div class="navbar-nav pt-1 justify-content-center">
      <a class="nav-item nav-link link-light mx-2" aria-current="page" href="{{url}}">Inicio</a>
      <a class="nav-item nav-link link-light mx-2" href="{{url}}/dataset/">Conjuntos de datos</a>
      <a class="nav-item nav-link link-light mx-2" href="{{sub_url}}/plan-apertura">Plan de apertura</a>
      <a class="nav-item nav-link link-light mx-2" href="{{sub_url}}/plan-accion">Plan de acción</a>
    </div>
  </div>
</nav>
